import * as React from "react";
import type { SVGProps } from "react";
const SvgIconSendMessage = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <g clipPath="url(#clip0_7066_5485)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.41.55C13.22.6 1.71 4.43 1.53 4.52c-.51.25-.86.71-.96 1.27-.07.38-.02.78.15 1.11.13.25.17.3 1.63 1.76l1.43 1.43-.05 1.72c-.03 1.08-.04 1.76-.03 1.82q.06.27.32.41c.1.06.28.07.39.04l1.14-.58 1.08-.55L7.7 14c1.16 1.16 1.2 1.2 1.5 1.32.24.1.4.13.66.13.27 0 .42-.02.64-.1.43-.16.8-.5 1-.9.06-.15 3.9-11.68 3.93-11.84s.04-.5 0-.66C15.3 1.3 14.84.8 14.23.6c-.25-.08-.57-.1-.82-.06M7.54 3.7c-3 1-5.49 1.84-5.53 1.87-.28.14-.4.51-.28.8.04.09.17.22 1.35 1.4L4.4 9.08l4.31-3.6c2.38-1.97 4.32-3.59 4.32-3.6zm2.07 2.52-4.7 3.92v.21l-.03 1.22-.02 1.01.79-.4.88-.45c.09-.04.12-.04.24-.04q.13 0 .22.06c.07.03.33.28 1.32 1.26 1.4 1.4 1.3 1.31 1.58 1.31.15 0 .18 0 .26-.04q.16-.08.26-.23c.07-.1 3.91-11.63 3.9-11.7 0-.04-.19.11-4.7 3.87"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_7066_5485">
        <rect width={16} height={16} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgIconSendMessage;
